<template>
    <el-dialog
        :title="dialogName"
        :visible.sync="visible"
        custom-class="image-dialog"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        @close="selectOver('cancel')"
        top="10vh"
        width="80%">
        <el-tabs v-model="imageActive" type="border-card" @tab-click="handleClickOutside">
            <el-tab-pane label="标准图库" name="0">

                <el-tabs v-model="active" @tab-click="handleClick">
                    <el-tab-pane :label="$t('topic.simulatedBag')" name="0" :disabled="isTipSelectBtnActive"></el-tab-pane>
                    <el-tab-pane :label="$t('topic.emptyPacket')" name="1" :disabled="isTipSelectBtnActive"></el-tab-pane>
                    <el-tab-pane :label="$t('topic.dangerous')" name="2" :disabled="!isTipSelectBtnActive"></el-tab-pane>
                    <el-form class="page-query" :inline="true" size="mini">
                        <el-form-item :label="$t('res.imgName')">
                            <el-input v-model="form.name" :placeholder="$t('tip.name')" clearable></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('c.knowledgePoint')" v-if="active!=1">
                            <el-cascader
                                v-model="form.knowledges"
                                :options="knowledgeMenu['Image']"
                                :props="cascadeProp"
                                :placeholder="$t('tip.knowledgePoint')"
                                :show-all-levels="false"
                                filterable
                                clearable
                            ></el-cascader>
                        </el-form-item>

                        <select-multiple :nameArrays="selectNames"
                                         v-if="visible"
                                        v-on:getViewCountVal="getViewCountVal"
                                        v-on:getImageOriginVal="getImageOriginVal">
                        </select-multiple>

                        <el-form-item v-if="isDoubleViewTip" :label="$t('res.perspective')">
                            <el-input :value="$t('res.doubleView')" disabled></el-input>
                        </el-form-item>

                        <!-- 图像包名称 imageBatch -->
                        <el-form-item label="图像包">
                            <el-select v-model="form.batchIds" placeholder="请选择图像包" style="width:240px;" multiple collapse-tags clearable>
                                <el-option :label="item.name" :value="item.id" v-for="item in imageBatchMenu"
                                           :key="item.id"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item :label="$t('res.uploadTime')">
                            <el-date-picker
                                v-model="form.createTime_after"
                                type="date"
                                :placeholder="$t('tip.startTime')"
                                :picker-options="pickerOptions1"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                            <span> {{$t('c.to')}} </span>
                            <el-date-picker
                                v-model="form.createTime_before"
                                type="date"
                                :placeholder="$t('tip.endTime')"
                                :picker-options="pickerOptions2"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="query(1)" round>{{$t('c.query')}}</el-button>
                        </el-form-item>
                    </el-form>
                    <el-row class="imageList" :gutter="20" v-loading="loading" v-viewer="{movable: false}">
                        <el-col class="imageList-item" :span="4" v-for="item in imageList" :key="item.id" :index="item.id" >
                            <div>
                                <el-card :body-style="{ padding: '2px' }" class="item-card" >
                                    <div class="item-image">
                                        <img :src="srcIsThumb(item)" class="image">
                                    </div>
                                    <div class="object-info" @click.prevent="clickCard(item.id)">
                                        <p class="object-name">{{item.byName}}</p>
                                        <div class="bottom">
                                            <p class="object-knowledge">{{item.knowledgeName}}</p>
                                            <div>
                                                <el-checkbox
                                                    v-model="selectItems"
                                                    :label="item.id"
                                                    :disabled="disabled[item.id]">{{ }}</el-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </el-card>
                            </div>

                        </el-col>

                    </el-row>
                    <!--<div v-show="page.total" style="text-align: center">-->
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        layout="total, prev, pager, next, jumper"
                        :total="pagTotal"
                        :page-size="12"
                        style="text-align: center;">
                    </el-pagination>
                    <!--</div>-->

                    <!--<p v-show="!page.total" style="margin-top: 20px;text-align: center;font-size: 18px;">-->
                    <!--<i class="nucfont inuc-empty-file"></i> 暂无数据-->
                    <!--</p>-->
                </el-tabs>


            </el-tab-pane>
            <el-tab-pane label="个人图库" name="1">

                <div class="person-image-wrap">
                    <div class="wrap-left">
                        <el-tree
                            ref="userTree"
                            :data="userTreeData"
                            node-key="id"
                            accordion
                            @node-click="handleTreeClick"
                            highlight-current="true">
                            <span class="slot-t-node" slot-scope="{ node, data }">
                                <span class="node-name">
                                    <span class="folder-type" :class="folderType(data.type)"></span>

                                    <span :title="data.name">{{treeNodeName(node,data)}}</span>
                                </span>
                           </span>
                        </el-tree>
                    </div>
                    <div class="wrap-right">
                        <p v-if="currentCheckNode" class="check-node">{{$t('res.currentCheckNode')}}：{{userNodePostion.join(' / ')}}</p>

                        <p class="check-tip" v-else><i class="nucfont inuc-tips"></i> {{$t('res.checkNodeTip')}}</p>

                        <el-row class="imageList" :gutter="20" v-loading="userLoading" v-viewer="{movable: false}">
                            <el-col class="imageList-item" :span="4" v-for="item in userImageList" :key="item.id" :index="item.id" >
                                <div>
                                    <el-card :body-style="{ padding: '2px' }" class="item-card"
                                        :class="{'disabled': isDoubleViewTip && item.viewCount===1}">
                                        <div class="item-image">
                                            <img :src="srcIsThumb(item)" class="image">
                                        </div>
                                        <div class="object-info" @click.prevent="clickCard(item.userImageId)">
                                            <p class="object-name">{{item.byName}}</p>
                                            <div class="bottom">
                                                <p class="object-knowledge">{{item.knowledgeName}}</p>
                                                <div>
                                                    <el-checkbox
                                                        v-model="selectItems"
                                                        :label="item.userImageId"
                                                        :disabled="disabled[item.userImageId]">{{ }}</el-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </el-card>
                                </div>
                            </el-col>
                        </el-row>

                        <el-pagination
                            @current-change="handleUserCurrentChange"
                            :current-page="currentUserPage"
                            layout="total, prev, pager, next, jumper"
                            :total="pagUserTotal"
                            :page-size="18"
                            style="text-align: center;">
                        </el-pagination>

                    </div>

                </div>


            </el-tab-pane>

        </el-tabs>

        <span slot="footer" class="dialog-footer">
            <el-button type="success" @click="selectOver('ok')">{{$t('c.confirm')}}</el-button>
            <el-button @click="selectOver('cancle')">{{$t('c.cancel')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import {mapGetters} from 'vuex';
    import api from '@/api';
    import selectMultiple from '@/components/Selectmultiple.vue';

    export default {
        components: {
            selectMultiple
        },
        props: {
            type: {
                type: Number // 3CT 4DR
            },
            dialogOpen: {
                type: Boolean,
                default: false,
            },
            isMultiSelect: { // 是否可以多选。这里默认应该是不能多选的
                type: Boolean,
                default: false
            },
            initData: {
                type: Object
            },

            /**
             * 单视角还是双视角，选择视角数对应的Tip
             * 单视角无限制，双视角只能插双视角
             */
            viewCount: {
                type: Number,
                default: 0
            },
            canSelectTip: { // 箱包的情况下不能插入Tip
                type: Boolean,
                default: true
            },
            activeTab: { // 那个选项是激活的。箱包、空包、危险品
                type: String,
                default: '0'
            },
        },
        data() {
            return {
                imageActive: '0',
                userTreeData: [],
                userImageList: [],
                userNodePostion: [],
                dialogNodePosition: [],
                currentCheckNode: '',

                isTipSelectBtnDisabled: true,
                dialogName: this.$t('topic.chooseImage'),
                knowledgeAll: false,
                visible: false,
                pageSize: 12,
                pagTotal: 0,
                currentPage: 1,
                pagUserTotal: 0,
                currentUserPage: 1,
                form: {
                    name: '',
                    knowledges: [],
                    viewCount: null,
                    origins: '',
                    batchIds: [],
                    createTime_before: '',
                    createTime_after: ''
                },
                selectNames: [
                    {key: "viewCount"},
                    {key: "imageOrigin"}
                ],
                knowledgeList: [],
                imageList: [],
                selectItems: [], //选中的项
                selectValue: [],
                loading: false,
                userLoading: false,
                disabled: {}, // 不能选择的图像信息对象
                active: '0',
                selectImages: [],
                cascadeProp: {
                    value: 'id',
                    label: 'value',
                    children: 'children'
                },

                imageBatchMenu: []
            }
        },

        created(){
            this.getImageBatchMenu()
        },

        computed: {
            ...mapGetters([
                'knowledgeMenu',
                'viewCountMenu'
            ]),
            isTipSelectBtnActive() {
                return this.canSelectTip && this.isTipSelectBtnDisabled
            },
            // 是否为双视角情况下的插入tip
            isDoubleViewTip() {
                return this.active == '2' && this.viewCount == 2
            },
            pickerOptions1() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.form.createTime_before) return false;
                        return time.getTime() > new Date(that.form.createTime_before).getTime()
                    },
                }
            },
            pickerOptions2() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.form.createTime_after) return false;
                        return time.getTime() < new Date(that.form.createTime_after).getTime()
                    },
                }
            },
        },
        methods: {
            async getImageBatchMenu() {
                let res;
                if(this.type == 4){
                    res = await api.getDRImageBatch()
                }else{
                    res = await api.getCTImageBatch()
                }
                this.imageBatchMenu = res.package
            },

            handleClickOutside(tab){
                console.log(tab);

                if(tab.index==1){
                    this.queryUser()
                }else{
                    this.query(1);
                }

            },
            queryUser(){
                this.getUserTree()
            },


            // 鼠标左击事件
            handleTreeClick (data,node) {
                if(data.type == 2){
                    this.userImageList = []
                    this.currentCheckNode = data.id
                    this.currentUserPage = 1
                    this.getUserImages(data.id)
                    this.userNodePostion = []
                    this.getTreeParentNode(node)
                }
                // this.foo()
            },
            //获取节点父级
            getTreeParentNode(node){
                if (node) {
                    if (node.parent) {
                        if(node.data.type == 3){
                            this.userNodePostion.unshift(this.$t('res.shareFrom',{share: node.data.name}))
                        }else{
                            this.userNodePostion.unshift(node.data.name) //在数组头部添加元素
                        }
                        this.getTreeParentNode(node.parent) //递归
                    }
                }
            },
            //获取dialog节点父级
            getDialogParentNode(node){
                if (node) {
                    if (node.parent) {
                        if(node.data.type == 3){
                            this.dialogNodePosition.unshift(this.$t('res.shareFrom',{share: node.data.name}))
                        }else{
                            this.dialogNodePosition.unshift(node.data.name) //在数组头部添加元素
                        }
                        this.getDialogParentNode(node.parent) //递归
                    }
                }
            },
            //点击用户图像包
            getUserImages(directoryID){
                let queryParams = {
                    viewMode: 'FilterDeletedKnowledge',
                    contentMode: this.active == 2 ? 'FtiOnly' : 'CtiAndEmpty',
                    pageNO: this.currentUserPage,
                    limit: 18
                }

                let apiUrl = ''
                if(this.type == 4){
                    apiUrl = api.getDRUserImage(directoryID, queryParams)
                }else{
                    apiUrl = api.getCTUserImage(directoryID, queryParams)
                }
                this.userLoading = true
                apiUrl.then(res => {
                    this.userImageList = res.package
                    this.pagUserTotal = res.total

                    setTimeout(() => {
                        this.userLoading = false
                    }, 300)
                })
            },
            getUserTree(){
                let apiUrl = ''
                let queryParams ={
                    viewMode: 'FilterDeletedKnowledge',
                    contentMode: this.active == 2 ? 'FtiOnly' : 'CtiAndEmpty'
                }
                if(this.type==4){
                    apiUrl = api.getDRUserTree(queryParams)
                }else{
                    apiUrl = api.getCTUserTree(queryParams)
                }
                apiUrl.then(res => {
                    this.userTreeData = res.package.children
                })
            },
            //用户目录树节点名称
            treeNodeName(node,data){
                let nodeName = data.name
                switch (node.level){
                    case 1:
                        nodeName = data.name.length > 10 ? (data.name.substring(0,8)+'...'): data.name
                        break
                    case 2:
                        nodeName = data.name.length > 8 ? (data.name.substring(0,6)+'...'): data.name
                        break
                    case 3:
                        nodeName = data.name.length > 6 ? (data.name.substring(0,5)+'...'): data.name
                        break
                    default:
                        nodeName = data.name.length > 5 ? (data.name.substring(0,3)+'...'): data.name
                        break
                }
                nodeName = data.type == 3 ?(this.$t('res.shareFrom',{share: data.name})) : (data.type == 2 ?(nodeName + '(' +data.size +')'):nodeName)
                return nodeName
            },
            //目录节点图标及颜色
            folderType(type){
                let color = 'nucfont '
                switch (type){
                    case 1:
                        color = color + 'inuc-folder folder'
                        break
                    case 2:
                        color = color + 'inuc-wenjianjia_f image'
                        break
                    case 3:
                        color = color + 'inuc-share share'
                        break
                    default:
                        break
                }
                return color
            },
            handleClick(tab, event) {
                this.query(1);
            },
            // 打开对话框的事件
            initDialog() {
                this.currentPage=1
                this.selectItems = this.initData.ids;
                this.initData.ids.forEach(id => {
                    this.disabled[id] = true;
                });
                this.form.knowledges = this.initData.knowledge

                // 限制双视角只能插双视角的tip
                if (this.isDoubleViewTip) {
                    this.form.viewCount = 2

                    this.$nextTick(() => {
                        $('.selector-viewCount').hide()
                    })
                }

                this.query();
            },
            resetDialog() {
                this.knowledgeAll = false;
                this.form = {
                    knowledge: [],
                };
                this.selectItems = [];
                this.disabled = {};
            },
            query(page) {
                if(page) this.currentPage = page;
                this.loading = true;

                let queryData = {
                    ...this.form,
                    pageNO: this.currentPage,
                    limit: 12,
                };
                if (!queryData.viewCount) delete queryData.viewCount;

                if (this.type === 4) {
                    let drtype;
                    if(this.active==1){
                        drtype='DR_Safe'
                        queryData.knowledges=[];
                        //queryData.name='';
                    }else if(this.active==2){
                        drtype='DR_Danger'
                        //queryData.viewCount = this.viewCount
                    }else if(this.active==0){
                        drtype='DR_Package'
                    }
                    queryData.type=drtype;
                    api.queryDRList(queryData).then((res) => {
                        this.loading = false;
                        this.imageList = res.package;
                        this.pagTotal = res.total;
                    });
                } else {
                    let cttype;
                    if(this.active==1){
                        cttype='CT_Safe'
                        queryData.knowledges=[];
                        queryData.name='';
                    }else if(this.active==2){
                        cttype='CT_Danger'
                    }else if(this.active==0){
                        cttype='CT_Package'
                    }
                    queryData.type=cttype;
                    api.queryCTList(queryData).then((res) => {
                        this.loading = false;
                        this.imageList = res.package;
                        this.pagTotal = res.total;
                    });
                }
            },
            //知识点改变
            knowledgeChange(data){
                this.currentPage=1
                this.form.knowledges=data;
                //this.query();
            },
            clickCard(id) {
                if (this.disabled[id]) return;
                let index = this.selectItems.indexOf(id);
                // 多选
                this.selectItems = []
                this.selectImages = []
                this.selectItems.push(id)
                let data;
                if(this.imageActive==1){
                    data = this.userImageList.find(item => item.userImageId === id)
                    data.userType = 2
                }else{
                    data = this.imageList.find(item => item.id === id)
                    data.userType = 1
                }
                data && this.selectImages.push(data)
            },
            selectOver(type) {
                if (type === 'ok') {
                    this.$emit('onSelectOver', this.selectValue);
                } else {
                    this.$emit('onSelectOver', [])
                }
            },
            knowledgeAllChange(val) {
                let knowledgeArr = []
                this.knowledgeList.forEach(ele => {
                    ele.children.forEach(v => {
                        knowledgeArr.push(v.id)
                    })
                })
                this.form.knowledge = val ? knowledgeArr : []
            },
            // 页码变化
            handleCurrentChange(val) {
                this.currentPage = val
                this.loading = true
                this.query()
            },
            // 页码变化
            handleUserCurrentChange(val) {
                this.currentUserPage = val
                this.userLoading = true
                this.getUserImages(this.currentCheckNode)
            },
            //图像是否有缩略图
            srcIsThumb(item){
                let url;
                if(item.thumbnails.length>0){
                    url=item.thumbnails[0].url
                }else{
                    url=item.dr[0].url
                }
                return url
            },

            getViewCountVal(data) {
                console.log(data)
                this.form.viewCount = data.filter(item => item!==0);
            },
            getImageOriginVal(data) {
                let rst = [];
                data.forEach(item => {
                    if (item>0) rst.push(item - 1)
                });
                this.form.origins = rst;
            },
        },
        watch: {
            selectItems(val) {
                this.selectValue = this.selectImages;
            },
            dialogOpen() {
                if (this.dialogOpen) {
                    this.active = this.activeTab
                    this.imageActive = '0'
                    this.isTipSelectBtnDisabled = true
                    this.userImageList = []
                    this.currentCheckNode = ''
                    this.currentUserPage = 1
                    this.userNodePostion = []
                    if (Number(this.active) !== 2) {
                        this.isTipSelectBtnDisabled = false
                    }
                    this.$nextTick(() => {
                        $('.sub-page').css({
                            overflow: 'hidden'
                        })
                    });
                    this.initDialog();
                    this.visible = true
                } else {
                    $('.sub-page').css({
                        overflow: 'auto'
                    });
                    this.resetDialog();
                    this.$nextTick(() => {
                        this.visible = false
                    })
                }
            }
        }
    }
</script>

<style lang="scss">
    .image-dialog {
        min-width: 1000px;
        .page-query{
            padding: 10px 2px 2px 7px;
            margin-bottom: 0;
            box-shadow: none;
        }
        .el-dialog__header {
            padding: 8px 15px;
        }
        // .el-dialog__body {
        //     padding-top: 0px;
        //     padding-bottom: 5px;
        //     background-color: #F8F8F8;
        // }
        .el-dialog__footer {
            padding: 5px 20px;
        }

        .dialog-body {
            display: flex;
        }
        .imageList{
            margin-top: 10px;
            min-height: 300px;
            .imageList-item{
                margin-bottom: 10px;
                .item-card{
                    padding: 0;
                    height: 180px;
                    .item-image{
                        height: 110px;
                        width: 100%;
                        text-align: center;
                        cursor: pointer;
                        img{
                            height: 100%;
                        }
                    }

                    &.disabled {
                        opacity: .7;
                        box-shadow: none;
                        cursor: not-allowed;

                        .item-image,
                        .object-info,
                        .el-checkbox__inner {
                            pointer-events: none;
                        }
                    }
                }
            }
        }

        .el-select-dropdown__item {
            max-width: 250px;
        }

        .el-form-item {
            margin-bottom: 10px;
        }
    }


</style>
<style lang="scss" scoped>
    .person-image-wrap{
        display: flex;
        .wrap-left{
            width:320px;
            border-right:1px dashed #666;
        }
        .wrap-right{
            width:100%;
            padding-left:20px;
        }
    }
    .slot-t-node{
        .node-name{
            padding-right: 3px;
            .folder-type{
                font-size: 16px;
                &.folder{
                    color: #ffcc00
                }
                &.image{
                    color: #00bcd4
                }
                &.share{
                    color: #a18fe8
                }
            }
            &.copy-move{
                .folder-type.folder,.folder-type.share{
                    color: #999
                }
            }
        }
    }
    .object-info{
        padding: 14px 2px 14px 14px;
        cursor: pointer;
    }
    .object-info .bottom{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 5px;
    }
    .object-name{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .object-knowledge{
        font-size: 12px;
        color: #676a6c;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-select-dropdown__item {
        /deep/ span {
            padding-right: 12px;
        }
    }
</style>
